import { createSlice } from "@reduxjs/toolkit";
import { IAllLeasesState } from "../../pages/machines/type";

// Define the initial state using that type
const initialState: IAllLeasesState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: "",
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null,
};

export const leasesSlice = createSlice({
    name: "allleases",
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: "",
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceAllLeases: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        setAllLease: (state, action) => {
            state.details = action.payload.data;
        },
    },
});

export const leasesActions = leasesSlice.actions;

export default leasesSlice.reducer;
